import appStoreBadge from '@/assets/app-store-badge-white.svg';
import { SectionGlow } from './SectionGlow';

const APP_STORE_URL = 'https://apps.apple.com/us/app/podbrief/id6759987252';

export function AppStoreCallout() {
  return (
    <section
      className="relative overflow-hidden py-20 md:py-28"
      style={{ backgroundColor: '#0c0a08' }}
    >
      <SectionGlow position="bottom" />
      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <p className="text-sm font-semibold tracking-[0.15em] uppercase text-primary mb-4">
          Also Available on iOS
        </p>

        <h2
          className="font-display font-normal text-text mb-6"
          style={{
            fontSize: 'clamp(2.5rem, 9vw, 4.25rem)',
            lineHeight: 0.95,
            letterSpacing: '-0.022em',
          }}
        >
          Built for your{' '}
          <em
            className="not-italic"
            style={{ fontStyle: 'italic', color: '#e0b352' }}
          >
            Commute.
          </em>
        </h2>

        <p
          className="font-body text-text/[0.62] max-w-xl mx-auto mb-8"
          style={{
            fontSize: 'clamp(1.0625rem, 1.5vw, 1.25rem)',
            lineHeight: 1.5,
            letterSpacing: '-0.005em',
          }}
        >
          PodBrief is available on iOS. Generate summaries at your desk and have
          them{' '}
          <span className="text-text font-bold">
            ready to listen the moment you walk out the door
          </span>
          .
        </p>

        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block hover:opacity-80 transition-opacity"
        >
          <img
            src={appStoreBadge}
            alt="Download on the App Store"
            className="h-12 mx-auto"
          />
        </a>
      </div>
    </section>
  );
}
